import { bizGet, bizPost } from '@/shared/api/bizClient';

import type {
  ConnectConflictListResponse,
  ConnectStatus,
  ConnectSyncConflict,
  ResolveConnectConflictPayload,
} from './types';

export async function getConnectStatus(): Promise<ConnectStatus> {
  return bizGet<ConnectStatus>('/biz/connect/status');
}

export async function getConnectConflicts(): Promise<ConnectConflictListResponse> {
  return bizGet<ConnectConflictListResponse>('/biz/connect/conflicts');
}

export async function resolveConnectConflict(
  conflictId: string,
  payload: ResolveConnectConflictPayload,
): Promise<ConnectSyncConflict> {
  return bizPost<ConnectSyncConflict, ResolveConnectConflictPayload>(
    `/biz/connect/conflicts/${conflictId}/resolve`,
    payload,
  );
}
